var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:("" + _vm.refName),staticClass:"text-wrap label",style:(("height: 56px; font-size: " + _vm.fontSize + "px; display: grid; align-items: center; color: " + _vm.color))},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }